/* eslint-disable default-case */
import produce from 'immer';

import {
  types,
  GetDeliveryLogRequest,
  GetDeliveryLogSuccess,
  GetDeliveryLogError,
  GetDeliveryLogPending,
  DeliveryLogActionTypes,
  DeliveryLogState
} from './types';

// Actions
export const actions = {
  getDeliveryLog: (payload: GetDeliveryLogRequest['payload']): DeliveryLogActionTypes => ({
    type: types.GET_DELIVERY_LOG.REQUEST,
    payload
  }),
  resetDeliveryLog: (): DeliveryLogActionTypes => ({ type: types.RESET_DELIVERY_LOG }),
  resetExportData: (): DeliveryLogActionTypes => ({ type: types.RESET_EXPORT_DATA })
};

// Initial State
export const initialState: DeliveryLogState = {
  data: [],
  hasMore: false,
  pending: false,
  error: null,
  totalRecords: 0,
  export: {
    data: [],
    pending: false
  }
};

// Reducer
export const reducer = (state: DeliveryLogState = initialState, action: DeliveryLogActionTypes): DeliveryLogState => {
  return produce(state, (draft) => {
    let payload;
    switch (action.type) {
      case types.GET_DELIVERY_LOG.PENDING:
        payload = (action as GetDeliveryLogPending).payload;
        if (payload.exportData) {
          draft.export.pending = payload.pending;
        } else {
          draft.pending = payload.pending;
        }
        break;
      case types.GET_DELIVERY_LOG.SUCCESS:
        payload = (action as GetDeliveryLogSuccess).payload;
        if (payload.exportData) {
          draft.export.data = payload.data;
        } else {
          draft.data = [...draft.data, ...payload.data];
          draft.hasMore = draft.data.length < payload.total;
          draft.totalRecords = payload.total;
        }
        break;
      case types.GET_DELIVERY_LOG.ERROR:
        draft.error = (action as GetDeliveryLogError).payload;
        break;
      case types.RESET_DELIVERY_LOG:
        draft.data = initialState.data;
        draft.hasMore = initialState.hasMore;
        draft.pending = initialState.pending;
        draft.error = initialState.error;
        draft.totalRecords = initialState.totalRecords;
        draft.export = initialState.export;
        break;
      case types.RESET_EXPORT_DATA:
        draft.export.data = initialState.export.data;
        break;
      default:
    }
  });
};
